import { render, staticRenderFns } from "./OnlineAnswerCount.vue?vue&type=template&id=566af5cd&"
import script from "./OnlineAnswerCount.vue?vue&type=script&lang=js&"
export * from "./OnlineAnswerCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports